<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="nav material2">
<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple [routerLink]="'/products'" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">local_offer</mat-icon>-->
<!--                <span>{{'Products'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->
    </div>

</div>